
<div class="row">
    <mat-icon style="cursor:pointer;text-align: right;width: 100%;margin-bottom: 13px;margin-top: -10px;" mat-button (click)="close()">close</mat-icon>
    <div class="col-md-12">
        <h4 class="title">Allocation History </h4>
    </div>

</div>

<div class="doc-table">
    <div class="card-box"> <p-table [value]="rows | filter:searchQR" styleClass="ui-table-customers" #tt [paginator]="true" [rows]="5"
        [rowHover]="true" [rowsPerPageOptions]="[5,10,25,50]" [showCurrentPageReport]="true"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [globalFilterFields]="['type']">

        <ng-template pTemplate="header">
            <tr class="thhead">
                <th class="th-1">
                    S.No
                </th>
                <th>
                    Bank Name
                </th>
                <th>
                    Portfolio Name
                </th>
                <th>
                    Product Name
                </th>
                <th>
                    Allocation Date
                </th>
                <th>
                    Allocation From
                </th>
                <th>
                    Allocated To
                </th>
                <th style="width: 110px;text-align:center">
                    Action
                </th>
            </tr>
        </ng-template>
     </p-table>  
    </div>
</div>

